<script lang="ts">
	import { classes } from '$lib/utils';
	import type MuxPlayerElement from '@mux/mux-player/*';
	import { getTranslate } from '@tolgee/svelte';
	import TrailerOverlayEnd from '../Video/Overlays/TrailerOverlayEnd.svelte';
	import TrailerOverlayStart from '../Video/Overlays/TrailerOverlayStart.svelte';
	import VideoPlayer from '../Video/VideoPlayer.svelte';

	const { t } = getTranslate();

	export let title: string;
	export let id: string;
	export let trailerUrl: string;
	export let overlayTitle: string;
	export let overlayHref: string;
	export let additionalClass: string = 'lg:ml-0';
	export let showHeadline: boolean = true;
	export let headlineWhite: boolean = false;
	export let trailerThumbnail: string = '';
	export let showThumbnail: boolean = false;
	export let showCenteredPlayButton: boolean = false;

	export let elementId: string = '';
	let muxPlayer: MuxPlayerElement;
</script>

<div
	on:click|stopPropagation
	on:keypress|stopPropagation
	id={elementId}
	class={classes(
		additionalClass,
		'mx-auto flex flex-col w-full md:w-[120%] lg:w-full xl:w-4/5 xl:mx-auto'
	)}
>
	{#if showHeadline}
		<div class="text-xl mb-3 {headlineWhite ? 'text-white' : ''}">
			{$t('courseTrailer.headline')}
		</div>
	{/if}

	<div>
		<VideoPlayer
			hasFullscreenMode={false}
			playbackId={trailerUrl}
			{id}
			{title}
			bind:muxPlayer
			hasOverlayStart={true}
			hasOverlayEnd={true}
		>
			<TrailerOverlayEnd slot="overlay-end" title={overlayTitle} href={overlayHref} />

			<TrailerOverlayStart
				{trailerThumbnail}
				slot="overlay-start"
				on:click={() => muxPlayer.play()}
				on:keypress={() => muxPlayer.play()}
				{showThumbnail}
				{showCenteredPlayButton}
			/>
		</VideoPlayer>
	</div>
</div>
